import { Store, ActionTree } from 'vuex';
import { ACTION_TYPES, MUTATION_TYPES } from './storeTypes';
import { feedbackServices } from '../services';
import { TFeedbackStore } from '../types';
import questionJson from '../question.json';
import HELPER from '@/app/utils/HELPER';
export const actions: ActionTree<TFeedbackStore, any> = {
  async [ACTION_TYPES.SUBMIT_FEEDBACK](store: Store<any>, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        store.commit(`${MUTATION_TYPES.UPDATE_SUBMIT_LOADING}`, true);
        const result = await feedbackServices.apiFeedback(payload);
        resolve(result);
      } catch (error) {
        reject(error);
      } finally {
        store.commit(`${MUTATION_TYPES.UPDATE_SUBMIT_LOADING}`, false);
      }
    });
  },
  async [ACTION_TYPES.FETCH_FEEDBACK_FORM](store: Store<any>, payload: string) {
    return new Promise(async (resolve, reject) => {
      try {
        const feedbackForms = store.state?.feedbackForm || {};
        if (!!feedbackForms[payload]) {
          return;
        }
        store.commit(`${MUTATION_TYPES.FETCH_FEEDBACK_FORM_LOADING}`, true);
        const result = await feedbackServices.apiGetFeedbackForm(payload);
        if (result.data?.feedback) {
          const { feedback } = result.data;
          const questions = JSON.parse(feedback.questions || '[]');
          const sortedQuestions = questions.sort((a: any, b: any) => (a.sort > b.sort ? 1 : -1));
          store.commit(`${MUTATION_TYPES.UPDATE_QUESTIONS}`, sortedQuestions);
          store.commit(`${MUTATION_TYPES.SET_FEEDBACK_FROM}`, feedback);
          resolve(result);
        } else {
          HELPER.showNotify('Feedback form not found', 'error', undefined);
          reject(result);
        }
      } catch (error) {
        HELPER.showNotify('Feedback form not found', 'error', undefined);
        reject(error);
      } finally {
        store.commit(`${MUTATION_TYPES.FETCH_FEEDBACK_FORM_LOADING}`, false);
      }
    });
  },
};
